import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { EnvelopeIcon, MapPinIcon } from '@heroicons/react/24/solid';
import Logo from '../assets/logo.svg';

export default function Footer() {
  const { t, i18n } = useTranslation();
  const langPrefix = i18n.language === 'et' ? '/et' : '/en';
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0f172a] text-slate-400 border-t border-slate-800 font-sans">
      <div className="container mx-auto px-6 py-12 md:py-16 max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          
          {/* 1. BRAND COLUMN */}
          <div className="space-y-6">
            <Link to={langPrefix} className="block w-32">
              <img src={Logo} alt="Mupax" className="h-8 w-auto opacity-90 hover:opacity-100 transition-opacity" />
            </Link>
            <p className="text-sm leading-relaxed max-w-xs text-slate-500">
              {t('footer.tagline')}
            </p>
            <div className="flex gap-4">
              {/* LinkedIn Only */}
              <a href="https://www.linkedin.com/company/mupax-oy" target="_blank" rel="noopener noreferrer" className="p-2 bg-slate-800 rounded-lg hover:bg-blue-600 hover:text-white transition-all" aria-label="Mupax LinkedIn">
                <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
              </a>
            </div>
          </div>

          {/* 2. SERVICES LINKS */}
          <div>
            <h4 className="text-white font-bold mb-6">{t('footer.services')}</h4>
            <ul className="space-y-3 text-sm">
              {(t('footer.service_links', { returnObjects: true }) || []).map((item, idx) => (
                <li key={idx}><Link to={`${langPrefix}${item.path}`} className="hover:text-cyan-400 transition-colors">{item.label}</Link></li>
              ))}
            </ul>
          </div>

          {/* 3. COMPANY LINKS */}
          <div>
            <h4 className="text-white font-bold mb-6">{t('footer.quick_links')}</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to={`${langPrefix}/about`} className="hover:text-blue-400 transition-colors">{t('nav.about')}</Link></li>
              <li><Link to={`${langPrefix}/blog`} className="hover:text-blue-400 transition-colors">{t('nav.blog')}</Link></li>
              <li><Link to={`${langPrefix}/contact`} className="hover:text-blue-400 transition-colors">{t('nav.contact')}</Link></li>
              <li><Link to={`${langPrefix}/privacy`} className="hover:text-blue-400 transition-colors">{t('footer.privacy')}</Link></li>
            </ul>
          </div>

          {/* 4. CONTACT */}
          <div>
            <h4 className="text-white font-bold mb-6">{t('nav.contact')}</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <EnvelopeIcon className="w-5 h-5 text-slate-500 mt-0.5" />
                <a href="mailto:info@mupax.eu" className="hover:text-white transition-colors">info@mupax.eu</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPinIcon className="w-5 h-5 text-slate-500 mt-0.5" />
                <span className="text-slate-500">Tallinn, Estonia</span>
              </li>
              <li className="text-slate-600 text-xs pt-1">
                Reg. nr 16379817
              </li>
            </ul>
          </div>

        </div>

        {/* BOTTOM BAR */}
        <div className="pt-8 border-t border-slate-800 text-xs text-center md:text-left flex flex-col md:flex-row justify-between items-center text-slate-500">
          <p>© {currentYear} Mupax OÜ. {t('footer.rights')}</p>
          <p className="mt-2 md:mt-0">Designed in Estonia by Mupax OÜ 🇪🇪</p>
        </div>
      </div>
    </footer>
  );
}